import { useEffect, useState } from "react";
import { useSnackbar } from 'notistack';
import axios from 'axios'
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Tooltip, Typography, Grid } from '@mui/material';
import { DeletePopUp, PageLoader } from "..";
import DeleteIcon from '@mui/icons-material/Delete';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import { globalDeleteService } from "../../utils/globalApiServices";
import { checkApiStatus } from "../../utils";
import { PermissionWrapper } from "../../wrappers";
import FilePreview from "./FilePreview";
import { Visibility as VisibilityIcon } from '@mui/icons-material';
import { trackActivity } from '../../utils/mixpanel';

const ShowAttachments = ({ attachmentsData, toggleModalFn, params, getResponseBack, url, moduleName, onViewDisabled, permissionKey }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [deleteAttachment, setDeleteAttachment] = useState({ modal: false, data: null });
    const [expiredLink, setExpiredLink] = useState({});
    const [filePreviewData, setFilePreviewData] = useState({ modal: false, data: null });
    
    useEffect(() => {
        const data = attachmentsData?.data?.attachments;
        if (!data) return;
        const interval = setInterval(() => {
            setExpiredLink(
                Object.fromEntries( data.map(item => [ item.slug, isUrlExpired(item.download_url) ]) )
            );
        }, 1000);
        return () => clearInterval(interval);
    }, [attachmentsData]);
  
    const onDeleteAttachment = () => {
        setLoading(true)
        globalDeleteService(`${url}/${deleteAttachment?.data?.slug}`).then(response => {
            if (checkApiStatus(response)) {
                setLoading(false)
                enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                setDeleteAttachment({ modal: false, data: null });
                getResponseBack(deleteAttachment?.data?.slug);
            } else {
                setLoading(false)
                enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
            }

        })
    }

    const onDownloadAttachment = async (file_url, fileName) => {
        setLoading(true);
        axios.get(file_url, { responseType: "arraybuffer" })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                setLoading(false);
            })
            .catch(() => {
                enqueueSnackbar(
                    "The download link has expired. Please reload the page.",
                    { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } }
                );
                setLoading(false);
            })
    };

    const isUrlExpired = (downloadUrl) => {
        const urlObj = new URL(downloadUrl);
        const amzDate = urlObj.searchParams.get("X-Amz-Date");
        const expires = Number(urlObj.searchParams.get("X-Amz-Expires")); 
        if (!amzDate || !expires) return true;
        const createdAt = new Date( amzDate.replace( /^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z$/, "$1-$2-$3T$4:$5:$6Z" ) );
        return Date.now() > createdAt.getTime() + expires * 1000;
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Attachments`, page_type: page_type, })
    }
    return (
        <>
            <Dialog
                open={true}
                // onClose={toggleModalFn}
                className='console-management-modal'
                maxWidth={'md'}
            >
                <DialogTitle id="scroll-dialog-title" sx={{ backgroundColor: '#c0c6df', padding: "5px 0px 5px 22px "}}>
                    {moduleName ? moduleName : "Name"} - Attachment(s)
                     {/* <PermissionWrapper extraProps={{ application: "lease_revamp", feature: permissionKey, operationType: ['U'] }}>
                       <Typography sx={{ fontSize: "10px", color: '#d32f2f' }}>{"Download link will be Valid for only 30 minutes"}</Typography>
                    </PermissionWrapper> */}
                </DialogTitle>
                <DialogContent dividers={true} sx={{p: "0 !important"}}>
                    <div style={{width: '460px'}}>
                        {attachmentsData?.data?.attachments?.length ?
                            <>
                                {attachmentsData?.data?.attachments.map((item, index) => {
                                    const isExpired = expiredLink[item.slug];
                                     return (
                                    <div className="flex-centered" style={{ borderBottom: '1px solid #d7d7d7', width: '100%', margin: '0', paddingTop: '4px'}}>
                                        {(() => {
                                            
                                            return (
                                                <>
                                                    <ul className="show-attachments-list-inline">
                                                        <Grid className="attachement-button-icon">
                                                        {/* <PermissionWrapper extraProps={{ application: "lease_revamp", feature: permissionKey, operationType: ['U'] }}> */}
                                                           <li className="list-inline-item">
                                                                <a onClick={() => { if (!isExpired) { onDownloadAttachment(item?.download_url, item?.file_name); } else { enqueueSnackbar( "The download link has expired. Please reload the page.", { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, } ); } handleItemClicked?.(`Download Icon (${item?.file_name})`) }} style={{ cursor: isExpired ? "not-allowed" : "pointer", }}>
                                                                        <Tooltip title={isExpired ? "Link Expired" : "Download"} arrow>
                                                                            <VerticalAlignBottomIcon fontSize="small" color={isExpired ? "disabled" : "primary"} />
                                                                        </Tooltip>
                                                                    </a>
                                                            </li>
                                                        {/* </PermissionWrapper> */}
                                                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: permissionKey, operationType: ['U'] }}>
                                                        {onViewDisabled ? null :<li className="list-inline-item">
                                                            <Tooltip title="Delete" arrow> <DeleteIcon  onClick={() => { setDeleteAttachment({ modal: true, data: item }); handleItemClicked?.(`Delete Icon (${item?.file_name})`) }} fontSize='small' color='error' /></Tooltip>
                                                        </li>}
                                                        </PermissionWrapper>
                                                        {/* <PermissionWrapper extraProps={{ application: "lease_revamp", feature: permissionKey, operationType: ['U'] }}> */}
                                                        <li className="list-inline-item">
                                                            <Tooltip title="View" arrow> <VisibilityIcon color="primary" onClick={()=>{ setFilePreviewData({ modal: true, data: item }); handleItemClicked?.(`View Icon (${item?.file_name})`) }} fontSize='small' /></Tooltip>
                                                        </li>
                                                        {/* </PermissionWrapper> */}
                                                        </Grid>
                                                        <li className="list-inline-item file-name" >
                                                            <span style={{fontSize:"15px"}}>{item?.file_name}</span>
                                                        </li>
                                                    </ul>
                                                </>
                                            )
                                        })()}
                                    </div>
                                     )
                                }
                                )}
                            </> :
                            <p style={{ textAlign: 'center', }}> No Attachment Available </p>
                        }
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { toggleModalFn(); handleItemClicked?.('Close Button') }} color="primary" size='small' variant="outlined">Close</Button>
                </DialogActions>
            </Dialog>
            {deleteAttachment.modal ?
                <DeletePopUp
                    modal={deleteAttachment.modal}
                    title='Delete Attachment'
                    content={`Are you sure, you want to Delete?`}
                    onToggleModal={() => setDeleteAttachment({ modal: false, data: null })}
                    onDeleteRecords={onDeleteAttachment}
                /> : null
            }
            {filePreviewData?.modal ?
                <FilePreview
                    filePreview={filePreviewData}
                    onToggleModal={() => setFilePreviewData({ modal: false, data: null })}
                /> : null}
            
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default ShowAttachments